import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {DokumentVerwaltungPageRoutingModule} from './dokument-verwaltung-routing.module';

import {DokumentVerwaltungPage} from './dokument-verwaltung.page';
import {NotificationService} from '@orga-app/providers/notification.service';
import {StoreModule} from '@ngrx/store';
import {reducers} from './dokument-verwaltung.reducer';
import {EffectsModule} from '@ngrx/effects';
import {
    VorlagenDokumentAktivierenEffects,
    VorlagenDokumentAktualisierenEffects,
    VorlagenDokumenteEffects,
    VorlagenDokumentEffects, VorlagenDokumentEntfernenEffects,
    VorlagenDokumentHinzufuegenEffects,
    VorlagenDokumentUploadAktualisierenEffects, VorlagenDokumentVeranstaltungsTypenAktivierenEffects, VorlagenDokumentVeranstaltungsTypenDeaktivierenEffects, VorlagenDokumentVeranstaltungsTypenEntfernenEffects, VorlagenDokumentVeranstaltungsTypenHinzufuegenEffects
} from '../../../../client-ngrx/vorlagen';
import {SopiScrollModule} from '../../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {EffectsWs} from './dokument-verwaltung.effects.ws';
import {SopiDirectivesModule} from '../../../../sopi/directives/sopi-directives.module';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';
import {DokumentVerwaltungBerechtigungenPage} from '../dokument-verwaltung-berechtigungen/dokument-verwaltung-berechtigungen.page';
import {DokumentVerwaltungBerechtigungenPageModule} from '../dokument-verwaltung-berechtigungen/dokument-verwaltung-berechtigungen.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        DokumentVerwaltungPageRoutingModule,

        StoreModule.forFeature('DokumentverwaltungPage', reducers),

        EffectsModule.forFeature([
            EffectsWs,

            // GET
            VorlagenDokumentEffects,
            VorlagenDokumenteEffects,

            // POST
            VorlagenDokumentAktivierenEffects,
            VorlagenDokumentAktualisierenEffects,
            VorlagenDokumentHinzufuegenEffects,
            VorlagenDokumentEntfernenEffects,
            VorlagenDokumentUploadAktualisierenEffects,
            VorlagenDokumentVeranstaltungsTypenAktivierenEffects,
            VorlagenDokumentVeranstaltungsTypenDeaktivierenEffects,
            VorlagenDokumentVeranstaltungsTypenHinzufuegenEffects,
            VorlagenDokumentVeranstaltungsTypenEntfernenEffects,
        ]),
        ReactiveFormsModule,
        SopiScrollModule,
        SopiDirectivesModule.forRoot(),
        SopiComponentsModule.forRoot(),
        DokumentVerwaltungBerechtigungenPageModule,
    ],
    declarations: [DokumentVerwaltungPage, DokumentVerwaltungBerechtigungenPage],
    providers: [
        NotificationService,
    ],
    entryComponents: [DokumentVerwaltungBerechtigungenPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DokumentVerwaltungPageModule {
}
